  query getCustomerStatistics(
    $clientId: ID
    $projectId: ID
    $productIds: [ID]
    $startDate: AWSDateTime
    $endDate: AWSDateTime
  ) {
    customerStats: SalesAnalyticsGetCustomerStats(
      startDate: $startDate
      endDate: $endDate
      clientId: $clientId
      projectId: $projectId
      productIds: $productIds
    ) {
        averageOrderValue
        maxOrderValue
        minOrderValue
        percentageOfMerchTicketBuyers
        percentageOfInEventPurchases
        percentageOfRepeatCustomers
    }
  }